import { isEqual } from 'lodash'
import Form from '../ui/Form'

export default class SettingsForm extends Form {

  componentWillMount(){
    this.props.fetchSets(this.modelName);
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  saveItem = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(data, this.newItem)) {
      this.cancelAdding();
    }
    else {
      this.props.addSets(this.modelName, data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.cancelAdding();
      });
    }
  }

  clearSearch = () => {
    if(this.props[this.modelName + 's'].search !== ''){
      this.props.searchSets(this.modelName, '');
    }
  }

  handleSearch = e => {
    const searchQuery = e.target.value.toLowerCase();
    this.props.searchSets(this.modelName, searchQuery);
  }

  handleSort = sortField => {
    const currField = this.props[this.modelName + 's'].sort.field;
    const currAsc = this.props[this.modelName + 's'].sort.asc;
    const asc = sortField === currField ? this.changeSort(currAsc) : 1;
    this.props.sortSets(this.modelName, {field: sortField, asc: asc});
  }

}



// WEBPACK FOOTER //
// ./src/components/settings/SettingsForm.jsx